import { defineComponent, $prefix, props, setup as _setup } from "@opentiny/vue-common";
import { renderless, api } from "@opentiny/vue-renderless/dropdown-item/vue";
import { iconDeltaLeft } from "@opentiny/vue-icon";
import Tooltip from "@opentiny/vue-tooltip";
import "@opentiny/vue-theme/dropdown-item/index.css";
function normalizeComponent(scriptExports, render, staticRenderFns, functionalTemplate, injectStyles, scopeId, moduleIdentifier, shadowMode) {
  var options = typeof scriptExports === "function" ? scriptExports.options : scriptExports;
  if (render) {
    options.render = render;
    options.staticRenderFns = staticRenderFns;
    options._compiled = true;
  }
  if (functionalTemplate) {
    options.functional = true;
  }
  if (scopeId) {
    options._scopeId = "data-v-" + scopeId;
  }
  var hook;
  if (moduleIdentifier) {
    hook = function hook2(context) {
      context = context || // cached call
      this.$vnode && this.$vnode.ssrContext || // stateful
      this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext;
      if (!context && typeof __VUE_SSR_CONTEXT__ !== "undefined") {
        context = __VUE_SSR_CONTEXT__;
      }
      if (injectStyles) {
        injectStyles.call(this, context);
      }
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier);
      }
    };
    options._ssrRegister = hook;
  } else if (injectStyles) {
    hook = shadowMode ? function() {
      injectStyles.call(this, (options.functional ? this.parent : this).$root.$options.shadowRoot);
    } : injectStyles;
  }
  if (hook) {
    if (options.functional) {
      options._injectStyles = hook;
      var originalRender = options.render;
      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context);
        return originalRender(h, context);
      };
    } else {
      var existing = options.beforeCreate;
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
    }
  }
  return {
    exports: scriptExports,
    options
  };
}

var __vue2_script = defineComponent({
  name: $prefix + "DropdownItem",
  componentName: $prefix + "DropdownItem",
  emits: ["item-click"],
  props: [].concat(props, ["disabled", "divided", "icon", "itemData", "title", "titleClass", "options", "type", "label", "appendToBody", "textField", "selected", "selectedField", "multiStage", "currentIndex", "tip", "tipPosition"]),
  components: {
    IconDeltaLeft: iconDeltaLeft(),
    TinyTooltip: Tooltip
  },
  setup: function setup(props2, context) {
    return _setup({
      props: props2,
      context,
      renderless,
      api
    });
  }
});
var render = function render2() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("tiny-tooltip", {
    attrs: {
      "content": _vm.getTip,
      "placement": _vm.tipPosition
    }
  }, [_c("li", {
    ref: "dropdownItem",
    staticClass: "tiny-dropdown-item tiny-dropdown-menu__item",
    class: {
      "is-disabled": _vm.disabled,
      "tiny-dropdown-item--divided tiny-dropdown-menu__item--divided": _vm.divided,
      "has-children": _vm.itemData.children && _vm.itemData.children.length
    },
    attrs: {
      "aria-disabled": _vm.disabled,
      "tabindex": _vm.disabled ? null : -1
    },
    on: {
      "click": function click($event) {
        $event.stopPropagation();
        return _vm.handleClick.apply(null, arguments);
      },
      "mousedown": function mousedown($event) {
        $event.stopPropagation();
      }
    }
  }, [_c("div", {
    staticClass: "tiny-dropdown-item__wrap"
  }, [_vm.itemData.children && _vm.itemData.children.length ? _c("span", {
    staticClass: "tiny-dropdown-item__expand tiny-dropdown-menu__item-expand"
  }, [_c(_vm.state.getIcon, {
    tag: "component"
  })], 1) : _vm._e(), _c("div", {
    staticClass: "tiny-dropdown-item__content tiny-dropdown-menu__item-content"
  }, [_vm.icon ? _c(_vm.icon, {
    tag: "component",
    staticClass: "tiny-svg-size"
  }) : _vm._e(), _vm._t("default", function() {
    return [_c("span", [_vm._v(_vm._s(_vm.label))])];
  }, {
    "itemData": _vm.itemData
  })], 2), _vm.itemData.children && _vm.itemData.children.length ? _c("ul", {
    class: ["tiny-dropdown-menu", "tiny-dropdown-item--child tiny-dropdown-menu__item--child", _vm.state.popperClass]
  }, _vm._l(_vm.itemData.children, function(item, index) {
    return _c("tiny-dropdown-item", {
      key: index,
      attrs: {
        "label": item[_vm.state.textField],
        "item-data": item,
        "icon": item.icon,
        "disabled": item.disabled,
        "divided": item.divided,
        "tip": item.tip,
        "tip-position": item.tipPosition
      }
    }, [_vm._t("default", null, {
      "itemData": item
    })], 2);
  }), 1) : _vm._e()])])]);
};
var staticRenderFns = [];
var __cssModules = {};
var __component__ = /* @__PURE__ */ normalizeComponent(__vue2_script, render, staticRenderFns, false, __vue2_injectStyles, null, null, null);
function __vue2_injectStyles(context) {
  for (var o in __cssModules) {
    this[o] = __cssModules[o];
  }
}
var pc = /* @__PURE__ */ function() {
  return __component__.exports;
}();
export {
  pc as default
};
